<template>
  <div class="mosaic-container">
    <div v-for="row in rows" class="mosaic-row">
      <div v-for="col in cols">
        <image-loader :url="getUrl(row, col)" :width="imageWidth" :height="imageHeight" :hue="hue"></image-loader>
      </div>
    </div>
  </div>
</template>

<script>
import KitsuApi from 'src/services/kitsu-api'

import ImageLoader from 'components/ImageLoader'

const imageWidth = 150
const ratio = 1.4216
const imageHeight = imageWidth * ratio
const hues = ['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'monochrome']

const kitsuApi = new KitsuApi()

function shuffle (array) {
  let currentIndex = array.length
  while (currentIndex !== 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1
    let temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }
  return array
}

export default {
  name: 'mosaic',
  components: {
    ImageLoader
  },
  data () {
    return {
      imageWidth,
      imageHeight,
      windowWidth: 100,
      windowHeight: 100,
      cols: 1,
      rows: 1,
      imageUrls: [],
      requesting: false,
      needMore: false,
      hue: 'red'
    }
  },
  methods: {
    getUrl (row = 1, col = 1) {
      let index = ((row - 1) * this.cols) + col - 1
      return index < this.imageUrls.length ? this.imageUrls[index] : ''
    },
    async getImageUrls (count = 1) {
      if (count <= 0) return

      if (this.requesting) {
        this.needMore = true
      } else {
        this.requesting = true
        this.needMore = false
        try {
          let animes = await kitsuApi.browse({
            year: [new Date().getFullYear() - 1, new Date().getFullYear()],
            sort: '-averageRating',
            limit: count,
            offset: this.imageUrls.length
          })
          animes = shuffle(animes)
          animes.forEach((anime) => {
            this.imageUrls.push(anime.attributes.posterImage.tiny)
          })
          this.requesting = false
          if (this.needMore) {
            this.getImageUrls((this.cols * this.rows) - this.imageUrls.length)
          }
        } catch (err) {
          console.error(err)
          this.requesting = false
        }
      }
    },
    updateWindowSize () {
      this.windowWidth = document.documentElement.clientWidth
      this.windowHeight = document.documentElement.clientHeight
      this.cols = parseInt(this.windowWidth / this.imageWidth, 10) + 1
      this.rows = parseInt(this.windowHeight / this.imageHeight, 10) + 1

      if (this.imageUrls.length < this.cols * this.rows) {
        this.getImageUrls((this.cols * this.rows) - this.imageUrls.length)
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.updateWindowSize()
      window.addEventListener('resize', this.updateWindowSize)
    })
    this.hue = hues[Math.floor(Math.random() * hues.length)]
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateWindowSize)
  }
}
</script>

<style scoped>
.mosaic-container {
  display: flex;
  flex-direction: column;
}

.mosaic-row {
  display: flex;
  flex-flow: row nowrap;
}
</style>



// WEBPACK FOOTER //
// Mosaic.vue?a6ca35ae